module.exports = __webpack_public_path__ + "static/media/john2-square.e7682762.jpg";